import React from "react";

const BlockNote: React.FC = (props) => {
  return <div className="notes">{props.children}</div>;
};

export default BlockNote;
